import { fetchMutation } from "../../../actions";
import { errorToDisplay } from "../../../helper/CommonFuncs";
import { ShowAlert } from "../../newCreateContent/CreateContentAlert";
import { filterValues } from "../component/shareCodes/actions/shareActions";
import { SUBMIT_TO_EHR } from "./notesAct"
export const formatCode = (codesOrdersData) => {
    let str = "";
    let isCode = false
    const codesOrderDataToMap = JSON.parse(JSON.stringify(codesOrdersData));
    if (codesOrderDataToMap?.ICD && codesOrderDataToMap?.ICD?.length > 0) {
        str = str + "ICD 10 Codes :\n";
        codesOrderDataToMap?.ICD?.map((s) => {
            return (str = str + `${s.code}\n`);
        });
        isCode = true
    }
    if (codesOrderDataToMap?.CPT && codesOrderDataToMap?.CPT?.length > 0) {
        str = str + "\nCPT Codes :";
        codesOrderDataToMap?.CPT?.map((s) => {
            return (str = str + `\n${s.code}`);
        });
        isCode = true
    }
    if (codesOrderDataToMap?.medicationOrders && codesOrderDataToMap?.medicationOrders?.length > 0) {
        str = str + "Medication :\n";
        codesOrderDataToMap?.medicationOrders?.map((s) => {
            return (str = str + `${s.order}\n`);
        });
    }
    if (codesOrderDataToMap?.testOrders && codesOrderDataToMap?.testOrders?.length > 0) {
        str = str + "\nTesting :";
        codesOrderDataToMap?.testOrders?.map((s) => {
            return (str = str + `\n${s.order}`);
        });
    }
    return { str, isCode };
};

export const shareCodes = (obj) => {
    const { noteId, codesOrdersData, selectedCodes, sucess = () => { }, errorApi = () => { } } = obj
    const clinicalData = {
        codes: {
            "CPT": filterValues(codesOrdersData.CPT, selectedCodes),
            "ICD": filterValues(codesOrdersData.ICD, selectedCodes)
        }
    }
    const payload = { noteId, clinicalData }
    fetchMutation(
        SUBMIT_TO_EHR,
        payload,
        (res) => {
            sucess()
            ShowAlert(res.data.sendCodeToEHR.message)
        },
        (error) => {
            ShowAlert(errorToDisplay(error), "error");
            errorApi()
        }
    );

}